import { useEffect, useState } from 'react';

const useTextClamp = (elementRef, isExpanded, content) => {
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    // Early return if conditions aren't met
    if (!elementRef.current || isExpanded || !content) {
      setIsClamped(false);
      return;
    }

    const checkIfClamped = () => {
      const element = elementRef.current;
      if (!element?.classList.contains('text-clamp-1')) {
        setIsClamped(false);
        return;
      }

      // Temporarily remove clamp to measure full height
      element.classList.remove('text-clamp-1');
      const fullHeight = element.scrollHeight;
      element.classList.add('text-clamp-1');

      setIsClamped(fullHeight > element.clientHeight);
    };

    // Check immediately
    checkIfClamped();

    // Listen for resize events
    window.addEventListener('resize', checkIfClamped);

    return () => {
      window.removeEventListener('resize', checkIfClamped);
    };
  }, [elementRef, isExpanded, content]);

  return isClamped;
};

export default useTextClamp;
